module.exports = __webpack_public_path__ + "static/media/CB_engagement_23.a4fada17.jpg";